export default class SubHero {
    constructor(elm) {
        const allVideos = elm.querySelectorAll('video');
        allVideos.forEach(video => video.addEventListener('loadeddata', () => {
            video.closest('.sub-hero__image-container__video--has-thumbnail')?.classList.add('sub-hero__image-container__video--loaded');
        }));
    }
}
